import BaseModelUnitProgramAllocation from "@/models/BaseModelUnitProgramAllocation.js";
import BaseModelUnitProgramAllocationDetail from "@/models/BaseModelUnitProgramAllocationDetail.js";

export const GridConfig = {
	columns: BaseModelUnitProgramAllocation.columns,
	grid: {
		gridId: 'UnitProgramAllocationGrid',
		height: 500,
		checkbox: true,
		edit: false,
		delete: false,
		info: true,
		pageSize: 100,
		groupable: true
	}
}

export const DetailGridConfig = {
	columns: BaseModelUnitProgramAllocationDetail.columns,
	grid: {
		gridId: 'UnitProgramAllocationDetailGrid',
		checkbox: true,
		pageSize: 100,
		height: 500,
		groupable: true,
	}
}

export const ToolBarConfig = {
	items: [
		{
			id: "btnAllocate",
			type: "button",
			text: "Start Allocation",
			icon:"calculator",
			showIcon: "toolbar",
			attributes: { "class": "btn btn-primary float-right-btn" }
		},
		{
			template: `<Label style="width:110px;">Select Period: </Label>
				<div id="kendo-select"><input id="dropdownTaxPeriod" style="width:120px;" /></div>`, 
				overflow: "never" 
			// template: `<Label style="width:200px;">Select Period: </Label>
			// <select id="dropdownTaxPeriod" class="form-control">

			// </select>`, 
			
		},
	]
}

export const DetailToolBarConfig = {
	items: [
		{
			id: "btnBack",
			type: "button",
			text: "Back to Allocation Summary",
			showIcon: "toolbar",
			icon: "undo",
			attributes: { "class": "btn btn-secondary float-right-btn" }
		},
	]
}

export const ProgramUpdatefields ={
	list: 'Program',
    columns: {
        Id: {
            class: 'id',
            dataName: 'Id',
            type: 'number',
            title: 'Id',
            width: 100,
            hidden: true
        },
        AllocationStatus: {
			class: "value",
			dataName: 'AllocationStatus',
			type: 'string',
			title: 'AllocationStatus',
			width: 100,
			hidden: true,
			readOnly: false
        },
        AllocationDate: {
			class: "value",
			dataName: 'AllocationDate',
			type: 'Date',
			title: 'AllocationDate',
			width: 100,
			hidden: true,
			readOnly: false
		}
    },
}